import SmartToyOutlined from "@mui/icons-material/SmartToyOutlined";
import { Box, Button } from "@mui/material";
import React from "react";
import { useRoleLabels } from "../../hooks/useRoleLabels";

interface CoachingStepActionsProps {
    isCurrent: boolean;
    waiverDone: boolean;
    coachingReady: boolean;
    startingAi: boolean;
    onInvite: () => void;
    onStartWithAi: () => void;
}

/**
 * Step-specific actions for the athlete "Set up your coaching" checklist row.
 */
const CoachingStepActions: React.FC<CoachingStepActionsProps> = ({
    isCurrent,
    waiverDone,
    coachingReady,
    startingAi,
    onInvite,
    onStartWithAi,
}) => {
    const { getRoleLabel } = useRoleLabels();
    if (coachingReady) return null;

    const coachLabel = getRoleLabel("coach");
    const guardianLabel = getRoleLabel("parent");

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems={{ xs: "flex-start", sm: "flex-end" }}
            gap={0.75}
            data-testid="coaching-step-actions"
        >
            <Button
                variant={isCurrent ? "contained" : "outlined"}
                color="secondary"
                size="small"
                disabled={!waiverDone}
                onClick={onInvite}
                data-attr="onboarding_step_coaching_invite"
                data-testid="onboarding-step-cta--coaching-invite"
            >
                Invite {coachLabel.toLowerCase()} or {guardianLabel.toLowerCase()}
            </Button>
            <Button
                variant="text"
                size="small"
                color="secondary"
                startIcon={<SmartToyOutlined />}
                onClick={onStartWithAi}
                disabled={!waiverDone || startingAi}
                data-attr="onboarding_start_with_ai"
                data-testid="onboarding-start-with-ai"
            >
                {startingAi ? "Starting…" : "Start with an AI coach"}
            </Button>
        </Box>
    );
};

export default CoachingStepActions;
